module.exports = "\r\n<div class=\"wait-container\" >  \r\n   <img class=\"wait-cursor\" src=\"assets/img/waiting2.gif\">\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/Proyectos/tpl viejo prueba/eflowTPL/src/app/components/wait-processing/wait-processing.component.html
// module id = ../../../../../src/app/components/wait-processing/wait-processing.component.html
// module chunks = main